/* eslint-disable */
import * as util from "@/api/toolkit";

const state = {
    formParamWidgetChatSt: {
        copy: false,
        header: {
            id: "",
            title: "",
            domain: "",
            mode_widget: "",
            fb_pixel_id: "",
            fb_pixel_event: "PageViews",
            fb_pixel_currency: "IDR",
            fb_pixel_amount: 0,
            g_tag_id: "",
            is_publish: 0
        },
        detail: [
            {
                operator_id: "",
                operator_priority: 0,
                operator_weight: 1
            }
        ]
    },
    formParamLinkGeneratorSt: {
        copy: false,
        header: {
            id: "",
            title: "",
            domain: "",
            slug: "",
            fb_pixel_id: "",
            fb_pixel_event: "PageViews",
            fb_pixel_currency: "IDR",
            fb_pixel_amount: 0,
            g_tag_id: "",
            chat_content: "",
            is_loading_page: 0,
            rotation_type: "sequencial",
            is_publish: 0
        },
        detail: [
            {
                operator_id: "",
                operator_priority: 0,
                operator_weight: 1
            }
        ]
    },
    isShowForm: false,
    formParamOperatorSt: {
        copy: false,
        id: "",
        internal_name: "",
        public_name: "",
        role_name: "",
        phone_number: "",
        greeting_message: "",
        photo: "",
        is_scheduling: 0,
        is_publish: 0,
        wh_sunday_status: 0,
        wh_sunday_start: "08:00",
        wh_sunday_start_hour: "08",
        wh_sunday_start_minute: "00",
        wh_sunday_end: "17:00",
        wh_sunday_end_hour: "17",
        wh_sunday_end_minute: "00",
        wh_monday_status: 0,
        wh_monday_start: "08:00",
        wh_monday_start_hour: "08",
        wh_monday_start_minute: "00",
        wh_monday_end: "17:00",
        wh_monday_end_hour: "17",
        wh_monday_end_minute: "00",
        wh_tuesday_status: 0,
        wh_tuesday_start: "08:00",
        wh_tuesday_start_hour: "08",
        wh_tuesday_start_minute: "00",
        wh_tuesday_end: "17:00",
        wh_tuesday_end_hour: "17",
        wh_tuesday_end_minute: "00",
        wh_wednesday_status: 0,
        wh_wednesday_start: "08:00",
        wh_wednesday_start_hour: "08",
        wh_wednesday_start_minute: "00",
        wh_wednesday_end: "17:00",
        wh_wednesday_end_hour: "17",
        wh_wednesday_end_minute: "00",
        wh_thursday_status: 0,
        wh_thursday_start: "08:00",
        wh_thursday_start_hour: "08",
        wh_thursday_start_minute: "00",
        wh_thursday_end: "17:00",
        wh_thursday_end_hour: "17",
        wh_thursday_end_minute: "00",
        wh_friday_status: 0,
        wh_friday_start: "08:00",
        wh_friday_start_hour: "08",
        wh_friday_start_minute: "00",
        wh_friday_end: "17:00",
        wh_friday_end_hour: "17",
        wh_friday_end_minute: "00",
        wh_saturday_status: 0,
        wh_saturday_start: "08:00",
        wh_saturday_start_hour: "08",
        wh_saturday_start_minute: "00",
        wh_saturday_end: "17:00",
        wh_saturday_end_hour: "17",
        wh_saturday_end_minute: "00"
    },
    formParamWorkingHoursSt: {
        id: "",
        member_id: "",
        wh_sunday_status: 0,
        wh_sunday_start: "08:00",
        wh_sunday_start_hour: "08",
        wh_sunday_start_minute: "00",
        wh_sunday_end: "17:00",
        wh_sunday_end_hour: "17",
        wh_sunday_end_minute: "00",
        wh_monday_status: 1,
        wh_monday_start: "08:00",
        wh_monday_start_hour: "08",
        wh_monday_start_minute: "00",
        wh_monday_end: "17:00",
        wh_monday_end_hour: "17",
        wh_monday_end_minute: "00",
        wh_tuesday_status: 1,
        wh_tuesday_start: "08:00",
        wh_tuesday_start_hour: "08",
        wh_tuesday_start_minute: "00",
        wh_tuesday_end: "17:00",
        wh_tuesday_end_hour: "17",
        wh_tuesday_end_minute: "00",
        wh_wednesday_status: 1,
        wh_wednesday_start: "08:00",
        wh_wednesday_start_hour: "08",
        wh_wednesday_start_minute: "00",
        wh_wednesday_end: "17:00",
        wh_wednesday_end_hour: "17",
        wh_wednesday_end_minute: "00",
        wh_thursday_status: 1,
        wh_thursday_start: "08:00",
        wh_thursday_start_hour: "08",
        wh_thursday_start_minute: "00",
        wh_thursday_end: "17:00",
        wh_thursday_end_hour: "17",
        wh_thursday_end_minute: "00",
        wh_friday_status: 1,
        wh_friday_start: "08:00",
        wh_friday_start_hour: "08",
        wh_friday_start_minute: "00",
        wh_friday_end: "17:00",
        wh_friday_end_hour: "17",
        wh_friday_end_minute: "00",
        wh_saturday_status: 0,
        wh_saturday_start: "08:00",
        wh_saturday_start_hour: "08",
        wh_saturday_start_minute: "00",
        wh_saturday_end: "17:00",
        wh_saturday_end_hour: "17",
        wh_saturday_end_minute: "00"
    },
};

const mutations = {
    SET_formParamWidgetChatSt: (state, value) => {
        state.formParamWidgetChatSt = value
    },
    SET_formParamLinkGeneratorSt: (state, value) => {
        state.formParamLinkGeneratorSt = value
    },
    SET_isShowForm: (state, value) => {
        state.isShowForm = value
    },
    SET_formParamOperatorSt: (state, value) => {
        state.formParamOperatorSt = value
    },
    SET_formParamWorkingHoursSt: (state, value) => {
        state.formParamWorkingHoursSt = value
    },
};

const actions = {
    actformParamWidgetChatSt({ commit }, data) {
        commit("SET_formParamWidgetChatSt", data);
    },
    listWidgetChatMode() {
        return new Promise((resolve, reject) => {
            util.listWidgetChatMode().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateWidgetChatDraft({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateWidgetChatDraft(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateWidgetChatPublish({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateWidgetChatPublish(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    storeWidgetChat({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.storeWidgetChat(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listWidgetChat({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listWidgetChat(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detailEditWidgetChat({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.detailEditWidgetChat(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detailWidgetChat({ commit }, id) {
        return new Promise((resolve, reject) => {
            util.detailWidgetChat(id).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    checkSlugLinkGenerator({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.checkSlugLinkGenerator(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    generateSlugLinkGenerator({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.generateSlugLinkGenerator(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actFormParamLinkGeneratorSt({ commit }, data) {
        commit("SET_formParamLinkGeneratorSt", data);
    },
    updateLinkGeneratorPublish({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateLinkGeneratorPublish(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateLinkGeneratorDraft({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateLinkGeneratorDraft(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listLinkGenerator({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listLinkGenerator(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detailLinkGenerator({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.detailLinkGenerator(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    storeLinkGenerator({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.storeLinkGenerator(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listDomainLinkGenerator({ commit }) {
        return new Promise((resolve, reject) => {
            util.listDomainLinkGenerator().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    listRotationType({ commit }) {
        return new Promise((resolve, reject) => {
            util.listRotationType().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateOperatorDraft({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateOperatorDraft(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateOperatorPublish({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.updateOperatorPublish(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    deleteOperator({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.deleteOperator(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detailOperator({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.detailOperator(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    storeOperator({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.storeOperator(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    setIsShowForm({ commit }, data) {
        commit("SET_isShowForm", data);
    },
    actformParamOperatorSt({ commit }, data) {
        commit("SET_formParamOperatorSt", data);
    },
    listOperator({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.listOperator(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actformParamWorkingHoursSt({ commit }, data) {
        commit("SET_formParamWorkingHoursSt", data);
    },
    storeWorkingHours({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.storeWorkingHours(params).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detailWorkingHours({ commit }, params) {
        return new Promise((resolve, reject) => {
            util.detailWorkingHours(params).then(response => {
                var { data } = response;
                commit("SET_formParamWorkingHoursSt", data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/toolkit.js